import { render, staticRenderFns } from "./CompletionBlock.vue?vue&type=template&id=291ecd62&scoped=true&"
import script from "./CompletionBlock.vue?vue&type=script&lang=js&"
export * from "./CompletionBlock.vue?vue&type=script&lang=js&"
import style0 from "./CompletionBlock.vue?vue&type=style&index=0&id=291ecd62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291ecd62",
  null
  
)

export default component.exports